import { Button, Heading, Paragraph } from '~elements'
import styles from 'components/elements/PortalModal/PortalModal.module.scss'
import { EventModalContent as EventModalContentType } from '~types'
import { useEffect, useId } from 'react'
import { getGtmLinkPosition } from '~analyticsUtils'

export interface EventModalContentProps extends EventModalContentType {
  setAriaAttributes?: (attributes: { labelledby?: string; describedby?: string }) => void
}

const MAX_DESCRIPTION_LENGTH = 160
const MAX_BUTTONS = 2

const EventModalContent = ({
  buttonGroup,
  description,
  disclaimer,
  statusBar,
  statusBarColor,
  title,
  setAriaAttributes
}: EventModalContentProps) => {
  const uniqueId = useId()
  const titleId = title ? `modal-title-${uniqueId}` : undefined
  const descriptionId = description?.html ? `modal-description-${uniqueId}` : undefined

  useEffect(() => {
    if (setAriaAttributes) {
      setAriaAttributes({
        labelledby: titleId,
        describedby: descriptionId
      })
    }
  }, [setAriaAttributes, titleId, descriptionId])

  function stripHtmlTags(html: string) {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html
    return tempDiv.textContent || tempDiv.innerText || ''
  }

  const plainText = description?.html ? stripHtmlTags(description.html) : ''

  const truncatedText =
    plainText.length > MAX_DESCRIPTION_LENGTH ? plainText.substring(0, MAX_DESCRIPTION_LENGTH) : plainText

  const limitedButtonGroup = buttonGroup?.slice(0, MAX_BUTTONS)
  const linkModule = 'event_modal_content'

  return (
    <div className={styles['modal-content--event']}>
      {statusBar && (
        <div className={styles['statusbar-container']}>
          <div className={`${styles.statusbar} ${styles[`statusbar-color-${statusBarColor}`]}`}>
            <p>{statusBar}</p>
          </div>
        </div>
      )}
      {title && (
        <Heading level='2' justify='center' id={titleId}>
          {title}
        </Heading>
      )}
      {description?.html && (
        <div className={styles['description-container']} id={descriptionId}>
          <Paragraph text={{ html: truncatedText }} />
        </div>
      )}

      {limitedButtonGroup && limitedButtonGroup.length > 0 && (
        <div className={styles['btn-container']}>
          {limitedButtonGroup.map((button, index) => {
            return (
              <Button
                key={`${button.title}_${index}`}
                {...button}
                analytics={{
                  linkModule: linkModule,
                  linkLocation: 'modal',
                  linkPosition: getGtmLinkPosition(limitedButtonGroup, index)
                }}
              />
            )
          })}
        </div>
      )}
      {disclaimer && (
        <div className={styles['disclaimer-container']}>
          <p>{disclaimer}</p>
        </div>
      )}
    </div>
  )
}

export default EventModalContent
